module.exports = __webpack_public_path__ + "public/img/server-icon.3c5f8dcd.png";